import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import AuthLayout from '../components/layout/AuthLayout';
import Input, { EmailIcon } from '../components/ui/Input';
import Button from '../components/ui/Button';
import { authService } from '../services/authService';
import './Auth.css';

const ResendVerification = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email) {
      setError('Email is required');
      return;
    }

    if (!/\S+@\S+\.\S+/.test(email)) {
      setError('Please enter a valid email address');
      return;
    }

    setLoading(true);
    setError('');
    setSuccess(false);

    try {
      await authService.resendVerification(email);
      setSuccess(true);
      setError('');
    } catch (err) {
      console.error('Resend verification failed:', err);
      
      let errorMessage = 'Failed to send verification email. Please try again.';
      
      if (err.response) {
        const status = err.response.status;
        const data = err.response.data;
        
        if (status === 404) {
          errorMessage = 'No account found with this email address.';
        } else if (status === 400 && data?.message?.includes('already verified')) {
          errorMessage = 'This email is already verified. Please try logging in.';
        } else if (data && data.message) {
          errorMessage = data.message;
        }
      } else if (err.message) {
        errorMessage = err.message;
      }
      
      setError(errorMessage);
      setSuccess(false);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout>
      <div className="auth-form">
        <div className="auth-header">
          <h1 className="auth-title">Resend Verification Email</h1>
          <p className="auth-subtitle">
            Enter your email address and we'll send you a new verification link
          </p>
        </div>

        <div className="auth-content">
          <form onSubmit={handleSubmit} className="auth-form-fields">
            {success && (
              <div className="success-message">
                <span className="message-text">
                  ✅ Verification email sent! Please check your inbox and spam folder.
                </span>
              </div>
            )}

            {error && (
              <div className="error-message general-error">
                <span className="message-text">{error}</span>
                <button 
                  type="button"
                  className="message-close-btn"
                  onClick={() => setError('')}
                  aria-label="Close error message"
                >
                  ×
                </button>
              </div>
            )}

            <div className="form-group">
              <label className="form-label">Email address</label>
              <Input
                type="email"
                name="email"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                icon={EmailIcon}
                error={error && !email}
              />
            </div>

            <div className="form-actions">
              <Button
                type="submit"
                variant="primary"
                size="large"
                loading={loading}
                className="submit-button"
              >
                Send Verification Email
              </Button>
              
              <div className="auth-footer">
                <span className="auth-footer-text">Remember your password?</span>
                <Link to="/login" className="auth-footer-link">
                  Back to Login
                </Link>
              </div>
            </div>
          </form>
        </div>
      </div>
    </AuthLayout>
  );
};

export default ResendVerification;

